import Header from "./components/header/header";
import Link from "./components/link/link";
import Footer from "./components/footer/footer";
const App = () => {
  return (
    <>
      <Header />
      <Link />
      <Footer/>
    </>
  );
};

export default App;
